import { useEffect, useState } from "react";
import CoverageGrid from "./CoverageGrid";
import LibraryList from "./LibraryList";
import KitBuilder from "./KitBuilder";
import BetaFeedbackList from "./BetaFeedbackList";
import KitOrdersList from "./KitOrdersList";
import NotifyListAdmin from "./NotifyListAdmin";

const SUBTABS = [["coverage", "Coverage"], ["library", "Library"], ["preview", "Preview & Beta"], ["feedback", "Beta Feedback"], ["orders", "Orders"], ["notify", "Notify List"]];

export default function StarterKitAdmin({ api }) {
  const [sub, setSub] = useState("coverage");
  const [opts, setOpts] = useState(null);
  const [filter, setFilter] = useState({ sport: "Basketball", age: "", type: "", status: "", q: "" });
  const [combo, setCombo] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => { api.get("/admin/starter-kit/options").then((r) => setOpts(r.data)).catch(() => setErr("Failed to load options")); }, []);

  const openCell = (sport, age) => { setFilter((f) => ({ ...f, sport, age })); setSub("library"); };
  const previewCell = (sport, age) => { setCombo({ sport, age }); setSub("preview"); };

  if (!opts) return <p className="text-[#6E6E6E]" data-testid="sk-loading">{err || "Loading…"}</p>;
  return (
    <div className="space-y-6" data-testid="starter-kit-admin">
      <div>
        <p className="text-xs uppercase tracking-[0.18em] text-[#DB9130] font-[IBM_Plex_Mono]">Just Got Voluntold · $9</p>
        <h2 className="font-head uppercase text-2xl text-[#1E1E1E]">Starter Kit Library</h2>
        <p className="text-sm text-[#6E6E6E] max-w-2xl">Human-approved content only. A sport/age goes live once every required slot has an approved item. Founder sections are approved by hand only.</p>
      </div>
      <div className="flex flex-wrap gap-2 border-b-2 border-[#D3CFC0] pb-3">
        {SUBTABS.map(([k, label]) => (
          <button key={k} data-testid={`sk-subtab-${k}`} onClick={() => setSub(k)}
            className={`px-4 py-1.5 text-xs font-head uppercase tracking-wide border-2 transition-colors ${sub === k ? "bg-[#DB9130] border-[#DB9130] text-[#1E1E1E]" : "border-[#D3CFC0] text-[#6E6E6E] hover:border-[#1E1E1E]"}`}>
            {label}
          </button>
        ))}
      </div>
      {sub === "coverage" && <CoverageGrid api={api} onOpen={openCell} onPreview={previewCell} />}
      {sub === "library" && <LibraryList api={api} opts={opts} filter={filter} setFilter={setFilter} />}
      {sub === "preview" && <KitBuilder api={api} opts={opts} initial={combo} />}
      {sub === "feedback" && <BetaFeedbackList api={api} />}
      {sub === "orders" && <KitOrdersList api={api} />}
      {sub === "notify" && <NotifyListAdmin api={api} />}
    </div>
  );
}
